import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SupervisseurDailModel {

  public sup_id : string;
  public sup_nom : string;
  public sup_email : string;
  public sup_phone : string;
}
